module.exports = __webpack_public_path__ + "static/booking-3-98f713f4ff73b7bad04c47a94649f995.svg";